import { createTheme } from '@mui/material/styles';
import { Theme, PaletteMode } from '@mui/material';

declare module '@mui/material/styles' {
  interface Palette {
    orange: string;
    lime: string;
    purple: {
      main: string;
      dark: string;
      darker: string;
      light: string;
    };
  }
  interface PaletteOptions {
    orange?: string;
    lime?: string;
    purple?: {
      main: string;
      dark: string;
      darker: string;
      light: string;
    };
  }
}

// All brand colors
export const brandColors = {
  purple: {
    main: '#4d1979',
    dark: '#2e1a47',
    darker: '#1a0f29',
    light: '#6b3497',
  },
  teal: '#00b2a9',
  lime: '#c1d82f',
  yellow: '#f0b323',
  orange: '#fa4616',
  red: '#af272f',
  black: '#000000',
  white: '#ffffff',
  grey: {
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
};

// Create theme based on mode
export const createAppTheme = (mode: PaletteMode): Theme => {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: brandColors.purple.main,
      },
      secondary: {
        main: brandColors.teal,
        contrastText: mode === 'light' ? brandColors.black : brandColors.white,
      },
      purple: brandColors.purple,
      orange: brandColors.orange,
      lime: brandColors.lime,
      background: {
        default: mode === 'light' ? brandColors.grey[100] : brandColors.grey[900],
        paper: mode === 'light' ? brandColors.white : brandColors.grey[800],
      },
      text: {
        primary: mode === 'light' ? brandColors.grey[900] : brandColors.grey[100],
        secondary: mode === 'light' ? brandColors.grey[800] : brandColors.grey[200],
      },
    },
    typography: {
      fontFamily: 'Lato, Arial, sans-serif',
      h1: {
        fontFamily: 'Roboto, Arial, sans-serif',
        fontWeight: 700,
      },
      h2: {
        fontFamily: 'Roboto, Arial, sans-serif',
        fontWeight: 600,
      },
      button: {
        fontFamily: 'Lato, Arial, sans-serif',
        textTransform: 'none',
      },
    },
  });
};

export default createAppTheme; 